(() => {
  const facetWrapper = document.getElementById('main-collection-filters');
  if (!facetWrapper) return;

  const defaultUrl = facetWrapper.dataset.defaultInStockUrl;
  if (!defaultUrl) return;

  const availabilityParam = 'filter.v.availability';
  const dismissedKey = `rs-default-in-stock-dismissed:${window.location.pathname}`;

  const currentParams = new URLSearchParams(window.location.search);

  // If the customer has deliberately removed the In Stock filter on this
  // collection during the current browser session, respect that choice.
  if (!currentParams.has(availabilityParam) && sessionStorage.getItem(dismissedKey) !== '1') {
    window.location.replace(defaultUrl);
    return;
  }

  // If the customer removes the availability filter (or uses Clear all),
  // remember that choice so we don't immediately add it back.
  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('a[href]');
      if (!link) return;

      const href = link.getAttribute('href');
      if (!href) return;

      let targetUrl;
      try {
        targetUrl = new URL(href, window.location.origin);
      } catch (error) {
        return;
      }

      if (
        currentParams.has(availabilityParam) &&
        !targetUrl.searchParams.has(availabilityParam) &&
        (link.closest('.active-facets') ||
          link.closest('.mobile-facets') ||
          link.closest('.facets-container'))
      ) {
        sessionStorage.setItem(dismissedKey, '1');
      }
    },
    true,
  );
})();
